import {
	BepAuthenticationProvider,
	FeatureFlagProvider,
	LayoutProvider,
	MeProvider,
} from '@/providers'
import { SocketProvider } from '@/providers/SocketProvider'
import { DialogsProvider } from '@toolpad/core/useDialogs'
import LayoutManager from '@views/Layout/LayoutManager'

import LookupProvider from './Lookups/LookupProvider'

export default function AuthenticatedProviders() {
	return (
		<BepAuthenticationProvider>
			<MeProvider>
				<LookupProvider>
					<FeatureFlagProvider>
						<LayoutProvider>
							<DialogsProvider>
								<SocketProvider>
									<LayoutManager />
								</SocketProvider>
							</DialogsProvider>
						</LayoutProvider>
					</FeatureFlagProvider>
				</LookupProvider>
			</MeProvider>
		</BepAuthenticationProvider>
	)
}
